import {
  CreateTagRequest,
  UpdateTagMetadataRequest,
} from './requests/tag-request.ts';
import { apiClient } from './client.tsx';
import {
  CreateTagResponse,
  GetTagListResponse,
  GetTagResponse,
  UpdateTagMetadataResponse,
} from './responses/tag-response.ts';

export const createTag = (request: CreateTagRequest) =>
  apiClient
    .post<CreateTagResponse>('/v2/tags', request)
    .then((res) => res.data.data);

export const getTag = (tagId: string) =>
  apiClient
    .get<GetTagResponse>(`/v2/tags/${tagId}`)
    .then((res) => res.data.data);

export const getTagList = () =>
  apiClient.get<GetTagListResponse>('/v2/tags').then((res) => res.data.data);

export const updateTagMetadata = (request: UpdateTagMetadataRequest) =>
  apiClient
    .put<UpdateTagMetadataResponse>(`/v2/tags/${request.tagId}`, request)
    .then((res) => res.data.data);

export const removeTag = (tagId: string) =>
  apiClient.delete(`/v2/tags/${tagId}`);
